import { gsap } from 'gsap';

/**
 * ページ内アンカーリンクの別ページ対応
 * このページに対象要素がなければ /#hash へ遷移する
 */
document.querySelectorAll( 'a[href^="#"]' ).forEach( ( link ) => {
	link.addEventListener( 'click', ( event ) => {
		const hash = link.getAttribute( 'href' );
		if ( ! hash || '#' === hash ) {
			return;
		}
		const target = document.querySelector( hash );
		if ( ! target ) {
			event.preventDefault();
			sessionStorage.setItem( 'techgala_scrollTo', hash );
			const home = window.location.pathname.startsWith( '/en/' ) ? '/en/' : '/';
			window.location.href = home;
		}
	} );
} );

const mm = gsap.matchMedia();
const nav = document.querySelector( '.header-sp-navigation' );
const navContainer = nav?.querySelector( '.wp-block-navigation__responsive-container[data-wp-class--has-modal-open]' );
const closeButton = nav?.querySelector( '.wp-block-navigation-overlay-close' );
const overlay = nav?.querySelector( '.wp-block-navigation__responsive-container-content' );
const overlayContainer = nav?.querySelector( '.wp-block-navigation__responsive-dialog' );
const overlayWrap = overlayContainer?.parentElement;
const headerEl = document.querySelector( 'header:not(.page-header)' );
const innerMenuGroup = nav?.querySelector( '.wp-block-navigation__overlay-container > .wp-block-group' );

function fixMenuHeight() {
    if ( ! innerMenuGroup || ! headerEl ) return;
    const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    const h = vh - headerEl.offsetHeight;
    innerMenuGroup.style.setProperty( 'min-height', h + 'px', 'important' );
    innerMenuGroup.style.setProperty( 'max-height', h + 'px', 'important' );
}

function clearMenuHeight() {
    if ( ! innerMenuGroup ) return;
    innerMenuGroup.style.removeProperty( 'min-height' );
    innerMenuGroup.style.removeProperty( 'max-height' );
    if ( window.visualViewport ) {
        window.visualViewport.removeEventListener( 'resize', fixMenuHeight );
    }
}

if ( nav && closeButton && overlay ) {
    mm.add( '(max-width: 1019.98px)', () => {
        let isClosing = false;
        let hasStartedOpening = false;

        const closeButtonProxy = document.createElement( 'button' );
        closeButtonProxy.type = 'button';
        closeButtonProxy.className = closeButton.className;
        const closeButtonAriaLabel = closeButton.getAttribute( 'aria-label' );
        if ( closeButtonAriaLabel ) {
            closeButtonProxy.setAttribute( 'aria-label', closeButtonAriaLabel );
        }
        if ( headerEl ) {
            headerEl.appendChild( closeButtonProxy );
        }
        gsap.set( closeButtonProxy, { opacity: 0, pointerEvents: 'none' } );
        let settleTimer = null;
        const observer = new MutationObserver( () => {
            if ( settleTimer ) {
                clearTimeout( settleTimer );
            }
            settleTimer = setTimeout( () => {
                settleTimer = null;
                handleMenuStateChange();
            }, 50 );
        } );
        function handleMenuStateChange() {
            if ( navContainer.classList.contains( 'is-menu-open' ) ) {
                // ハンバーガーを開くたびに、サブメニューの開閉状態を初期値（閉じた状態）に
                // 強制リセットする。WP標準側(Interactivity API)の挙動により、モーダルを
                // 開く度に各サブメニューの aria-expanded が true（展開済み）に再セットされて
                // しまうため、開いた直後にこちらで閉じ直す。
                // (.has-parent-link は常時展開の仕様のため対象外。)
                document.querySelectorAll(
                    '.wp-block-navigation__overlay-container .wp-block-navigation-item.has-child:not(.has-parent-link) > .wp-block-navigation-item__content.wp-block-navigation-submenu__toggle'
                ).forEach( ( toggle ) => {
                    toggle.setAttribute( 'aria-expanded', 'false' );
                } );
                isClosing = false;
                gsap.set( closeButtonProxy, { pointerEvents: 'auto' } );
                gsap.to( closeButtonProxy, { opacity: 1, duration: 0.2, ease: 'power2.out', overwrite: 'auto' } );
                fixMenuHeight();
                if ( window.visualViewport ) {
                    window.visualViewport.addEventListener( 'resize', fixMenuHeight );
                }
                if ( hasStartedOpening ) {
                    return;
                }
                hasStartedOpening = true;
                requestAnimationFrame( () => {
                    const tlOpen = gsap.timeline();
                    tlOpen
                        .fromTo( overlayContainer, { yPercent: -100 }, { yPercent: 0, duration: 0.5, ease: 'power2.out' }, '-=0.4' )
                        .fromTo( overlayContainer, { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'power2.out' }, '-=0.3' );
                } );
            } else if ( ! isClosing ) {
                hasStartedOpening = false;
                gsap.set( overlayContainer, { opacity: 0, yPercent: -100 } );
                gsap.to( closeButtonProxy, {
                    opacity: 0,
                    duration: 0.15,
                    overwrite: 'auto',
                    onComplete: () => gsap.set( closeButtonProxy, { pointerEvents: 'none' } ),
                } );
            }
        }
        observer.observe( navContainer, { attributes: true, attributeFilter: [ 'class' ] } );
        handleMenuStateChange();
        const handleClose = ( e ) => {
            e.stopPropagation();
            if ( isClosing ) return;
            isClosing = true;
            gsap.set( closeButtonProxy, { pointerEvents: 'none' } );
            const headerBottom = headerEl ? Math.round( headerEl.getBoundingClientRect().bottom ) : 60;
            const wrapTop = overlayWrap ? Math.round( overlayWrap.getBoundingClientRect().top ) : 0;
            const clipInset = Math.max( 0, headerBottom - wrapTop );
            const tlClose = gsap.timeline( {
                onComplete: () => {
                    closeButton.click();
                    if ( overlayWrap ) gsap.set( overlayWrap, { clearProps: 'clipPath' } );
                    clearMenuHeight();
                    isClosing = false;
                },
            } );
            tlClose
                .to( closeButtonProxy, { opacity: 0, duration: 0.2, ease: 'power2.in' } )
                .to( overlayContainer, { opacity: 0, duration: 0.5, ease: 'power2.in' } )
                .set( overlayWrap, { clipPath: `inset(${ clipInset }px 0 0 0)` }, '-=0.3' )
                .to( overlayContainer, { yPercent: -100, duration: 0.6, ease: 'power2.in' }, '-=0.3' );
        };
        closeButtonProxy.addEventListener( 'click', handleClose );
        return () => {
            observer.disconnect();
            if ( settleTimer ) {
                clearTimeout( settleTimer );
            }
            closeButtonProxy.removeEventListener( 'click', handleClose );
            if ( navContainer.classList.contains( 'is-menu-open' ) ) {
                closeButton.click();
            }
            clearMenuHeight();
            gsap.set( overlayContainer, { clearProps: 'all' } );
            if ( overlayWrap ) gsap.set( overlayWrap, { clearProps: 'clipPath' } );
            if ( closeButtonProxy.parentElement ) {
                closeButtonProxy.parentElement.removeChild( closeButtonProxy );
            }
        };
    } );
}

/**
 * モバイルのメガメニュー(overlay内)のサブメニュー開閉制御。
 *
 * 仕様:
 * ・サブメニューを持つ親は、WordPress標準の挙動では常に<button>として
 *   レンダリングされる（親自体にリンクを設定していても<a>にはならない）。
 *   親にリンクを設定している場合、コアはサブメニューの先頭に「親と同じ
 *   ラベル・リンク先を持つ複製項目」を自動生成する（リンク未設定の場合も
 *   複製項目自体は生成されるが、リンク先は "#" になる）。
 *   そのため、この複製項目のリンク先が "#" 以外の実URLかどうかで
 *   「親にリンクがあるかどうか」を判定する。
 * ・親にリンクがある項目（.has-parent-link）は開閉トグルとして扱わず、
 *   常に展開したリンク一覧として表示する。矢印アイコンクリックは無視し、
 *   ラベルクリックのみ複製項目が持つリンク先へ遷移させる。
 * ・親にリンクがない項目（通常のトグルのみの<button>）は、ラベル・矢印
 *   アイコンのどちらをクリックしても開閉のみを行う（ページ遷移はしない）。
 *
 * 以前はWP標準のクリック処理(Interactivity APIのtoggleMenuOnClick)に
 * 委ねていたが、1つのサブメニューを開いた状態で別のサブメニューの矢印を
 * 押すと、新しい方は開かずに先に開いていた方が閉じてしまう不具合があった。
 * これはWP標準側の内部状態管理と、当時実装していた「トグルボタンのクリックを
 * 代理発火させる」処理が干渉していたことが原因と考えられる。
 * そのため、開閉状態の管理を完全に自前で行い、WP標準の処理には一切委ねない
 * ようにする(documentのキャプチャフェーズでクリックを横取りし、WP側の
 * ハンドラーには到達させない)。これにより各項目は完全に独立して開閉でき、
 * 複数の項目を同時に開いた状態でも問題ない。
 */
( function () {
    const overlay = document.querySelector( '.wp-block-navigation__overlay-container' );
    if ( ! overlay ) return;

    overlay.querySelectorAll( '.wp-block-navigation-item.has-child' ).forEach( ( item ) => {
        const duplicateLink = item.querySelector(
            ':scope > .wp-block-navigation__submenu-container > .wp-block-navigation-item:first-child > a.wp-block-navigation-item__content'
        );
        if ( ! duplicateLink ) return;

        const href = duplicateLink.getAttribute( 'href' );
        if ( ! href || '#' === href ) return;

        item.classList.add( 'has-parent-link' );
        item.dataset.parentHref = href;

        const icon = item.querySelector( ':scope > .wp-block-navigation__submenu-icon' );
        if ( icon ) {
            icon.setAttribute( 'aria-expanded', 'true' );
        }
        const submenu = item.querySelector( ':scope > .wp-block-navigation__submenu-container' );
        if ( submenu && submenu.hasAttribute( 'hidden' ) ) {
            submenu.removeAttribute( 'hidden' );
        }
    } );

    document.addEventListener( 'click', ( event ) => {
        const hit = event.target.closest(
            '.wp-block-navigation-item__content.wp-block-navigation-submenu__toggle, .wp-block-navigation__submenu-icon'
        );
        if ( ! hit || ! overlay.contains( hit ) ) return;

        const item = hit.closest( '.wp-block-navigation-item.has-child' );
        if ( ! item ) return;

        if ( item.classList.contains( 'has-parent-link' ) ) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            if (
                hit.classList.contains( 'wp-block-navigation-item__content' ) &&
                item.dataset.parentHref
            ) {
                window.location.href = item.dataset.parentHref;
            }
            return;
        }

        const toggle = item.querySelector( ':scope > .wp-block-navigation-item__content.wp-block-navigation-submenu__toggle' );
        if ( ! toggle || 'BUTTON' !== toggle.tagName ) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const isOpen = toggle.getAttribute( 'aria-expanded' ) === 'true';
        toggle.setAttribute( 'aria-expanded', String( ! isOpen ) );
    }, true );
} )();

/**
 * PCのメガメニュー(ドロップダウン)の水平位置を、
 * 該当するトリガーリンクの左端 + 16px に合わせる。
 * position: fixed で viewport 基準のため、画面幅・レイアウト変更時に
 * 都度リンクの位置を測って left(px) を直接指定する。
 */
( function () {
    const pcNav = document.querySelector( '.header-pc-navigation' );
    if ( ! pcNav ) return;

    const OFFSET = 16;

    const triggers = Array.from( pcNav.querySelectorAll( '.wp-block-navigation-item' ) )
        .map( ( item ) => {
            const submenu = item.querySelector( ':scope > .wp-block-navigation__submenu-container' );
            const link = item.querySelector( ':scope > .wp-block-navigation-item__content' );
            return submenu && link ? { item, link, submenu } : null;
        } )
        .filter( Boolean );

    if ( ! triggers.length ) return;

    function updatePosition( { link, submenu } ) {
        const rect = link.getBoundingClientRect();
        submenu.style.left = `${ Math.round( rect.left + OFFSET ) }px`;
    }

    function updateAll() {
        triggers.forEach( updatePosition );
    }

    updateAll();
    window.addEventListener( 'resize', updateAll );

    triggers.forEach( ( trigger ) => {
        const observer = new MutationObserver( () => updatePosition( trigger ) );
        observer.observe( trigger.item, { attributes: true, attributeFilter: [ 'class' ], subtree: true } );
    } );

    /**
     * ホバーでメガメニューを開閉する。
     * リンクとパネルの間には隙間があり、CSSの:hoverだけに頼ると
     * その隙間をマウスが通過する一瞬だけホバーが外れてパネルが
     * 閉じてしまい、中身をクリックできなくなることがある。
     * そのため実際の開閉は is-hover-open クラスをJSで管理し、
     * 離れてもすぐには閉じず、少し待ってから閉じるようにする。
     */
    const HOVER_OPEN_CLASS = 'is-hover-open';
    const CLOSE_DELAY = 500; // ms

    /**
     * 別のメガメニューが開いたら、それ以外は即座に閉じる。
     * hoverで開いているものは is-hover-open を外すだけでよいが、
     * クリックで開いている(aria-expanded=true)ものはWP側の状態と
     * ズレないよう、トグルボタンを再クリックして正しく閉じる。
     *
     * @param {Element} currentItem 開いたままにしたい .wp-block-navigation-item
     */
    function closeOtherMegaMenus( currentItem ) {
        triggers.forEach( ( other ) => {
            if ( other.item === currentItem ) {
                return;
            }
            if ( other.item.classList.contains( HOVER_OPEN_CLASS ) ) {
                other.item.classList.remove( HOVER_OPEN_CLASS );
            }
            if ( 'true' === other.link.getAttribute( 'aria-expanded' ) ) {
                other.link.click();
            }
        } );
    }

    triggers.forEach( ( trigger ) => {
        const { item, link, submenu } = trigger;
        let closeTimer = null;

        const open = () => {
            if ( closeTimer ) {
                clearTimeout( closeTimer );
                closeTimer = null;
            }
            item.classList.add( HOVER_OPEN_CLASS );
            closeOtherMegaMenus( item );
        };

        const scheduleClose = () => {
            if ( closeTimer ) {
                clearTimeout( closeTimer );
            }
            closeTimer = setTimeout( () => {
                item.classList.remove( HOVER_OPEN_CLASS );
                closeTimer = null;
            }, CLOSE_DELAY );
        };

        item.addEventListener( 'mouseenter', open );
        item.addEventListener( 'mouseleave', scheduleClose );
        submenu.addEventListener( 'mouseenter', open );
        submenu.addEventListener( 'mouseleave', scheduleClose );

        link.addEventListener( 'click', () => {
            setTimeout( () => {
                if ( 'true' === link.getAttribute( 'aria-expanded' ) ) {
                    closeOtherMegaMenus( item );
                }
            }, 0 );
        } );
    } );
} )();
